import React from 'react';

import i18n from '@i18n';
import { handleDispatch } from '@/common/client';
import Article from '@/article/views/Article';
import { Button } from 'nike-ui/src/components/button/Button';
import { HOME } from '@/routing/routes';

export default function() {
    return (
        <div className="logout layout-rw">
            <Article articleCode="logout" className="markdown-logout" />
            <div className="button-box">
                <Button onClick={handleDispatch(['navigate', HOME])} label={i18n('commons.terms.hlavnaStranka')} />
            </div>
        </div>
    );
}
